module.exports = "\"data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Ccircle cx='3' cy='3' r='3' fill='%230E1C2C' /%3E %3C/svg%3E\""


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/bullet.svg
// module id = 116
// module chunks = 0